import React from 'react';
import { Box, Typography } from '@mui/material';

const WelcomePage = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "center", textAlign: 'center', py: 6, px: 3, minHeight: '80vh' }}>

            <Box sx={{
                width: 120, height: 120, borderRadius: '50%',
                border: '3px solid #378ADD', background: '#E6F1FB',
                display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2,
            }}>
                <img
                    src={process.env.PUBLIC_URL + "/emblem_big.png"}
                    alt="National Emblem"
                    style={{ width: 80, height: 'auto', objectFit: 'contain' }}
                />
            </Box>

            <Box sx={{
                display: 'inline-block', background: '#E6F1FB', color: '#0C447C',
                fontSize: 11, fontWeight: 500, letterSpacing: 1.5,
                textTransform: 'uppercase', px: 2, py: 0.5, borderRadius: '20px',
                border: '0.5px solid #85B7EB', mb: 1.5,
            }}>
                Government of Gujarat · R&amp;B Department
            </Box>

            <Typography sx={{ fontSize: { xs: 24, md: 30 }, fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
                Welcome to Roads and Buildings Department Dashboard
            </Typography>

            <Typography sx={{ fontSize: 15, color: 'text.secondary', mb: 3 }}>
                Roads and Buildings Department — Integrated Monitoring System
            </Typography>

            <Box sx={{ width: 60, height: 3, background: '#378ADD', borderRadius: 1, mb: 4 }} />

            {/* <Box sx={{
                background: '#f8fafc', border: '0.5px solid', borderColor: 'divider',
                borderRadius: 1.5, p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5, maxWidth: 600,
            }}>
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: '#EF9F27', flexShrink: 0 }} />
                <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
                    You have no dashboard modules assigned. Please contact your administrator to request access.
                </Typography>
            </Box> */}

        </Box>
    );
};

export default WelcomePage;